import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import SidebarCardError from 'customer-data-sidebar/SidebarCardError';
import Loadable from 'UIComponents/decorators/Loadable';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = () => /*#__PURE__*/_jsx(UIFlex, {
  align: "center",
  justify: "center",
  className: "relative",
  style: {
    height: 250
  },
  children: /*#__PURE__*/_jsx(UILoadingOverlay, {
    contextual: true
  })
});
LoadingComponent.displayName = 'LoadingComponent';
export function makeAsyncCard({
  loader
}) {
  let retries = 1;
  return Loadable({
    loader,
    LoadingComponent,
    // eslint-disable-next-line react/display-name
    ErrorComponent: ({
      retry
    }) => {
      if (retries > 0) {
        retry();
        retries -= 1;
        return /*#__PURE__*/_jsx(LoadingComponent, {});
      } else {
        return /*#__PURE__*/_jsx(SidebarCardError, {});
      }
    }
  });
}